export default __webpack_public_path__ + "static/media/greece.86a67e45.webp";